"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/* eslint-disable max-statements */
/** @jsx jsx */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const b_1 = __importDefault(require("b_"));
const pythia_libs_1 = require("@yandex-int/pythia-libs");
const question_1 = __importDefault(require("../question"));
const question_image_clickmap_styles_1 = __importDefault(require("./question-image-clickmap.styles"));
const b = b_1.default.with('question-image-clickmap');
const DEFAULT_PROPS = {
    handleClick: () => { },
    handleLoadImage: () => { },
    id: 0,
    children: [],
    areas: [],
    value: []
};
class ImageClickMap extends react_2.Component {
    constructor(props) {
        super(props);
        this.onClickImage = e => {
            const { areas, handleClick, value } = this.props;
            const image = this.imageRef.current;
            if (value.some(({ event }) => event === 'click_target'))
                return;
            if (!image) {
                return;
            }
            const { left, top, width, height } = image.getBoundingClientRect();
            const x = (0, pythia_libs_1.normalizeCoordinate)(e.clientX, left, width);
            const y = (0, pythia_libs_1.normalizeCoordinate)(e.clientY, top, height);
            const isAreaClicked = (0, pythia_libs_1.getIsAreaClicked)(areas, { x, y });
            if (isAreaClicked) {
                handleClick({ x, y, timestamp: Date.now(), isTarget: true });
            }
            else {
                handleClick({ x, y, timestamp: Date.now() });
            }
        };
        this.onLoadImage = () => {
            if (!this.state.isImageLoaded) {
                this.setState({ isImageLoaded: true });
                this.props.handleLoadImage({ timestamp: Date.now() });
            }
        };
        this.imageRef = (0, react_2.createRef)();
        this.state = { isImageLoaded: false };
    }
    componentDidMount() {
        const image = this.imageRef.current;
        if (image && image.complete) {
            this.onLoadImage();
        }
    }
    render() {
        const _a = this.props, { id, value = [], image, areas, imageLabel, children } = _a, rest = __rest(_a, ["id", "value", "image", "areas", "imageLabel", "children"]);
        const clicks = value
            .filter(({ event }) => event === 'click')
            .map(({ coordinates: { x, y } }) => ({ x, y }));
        return ((0, jsx_runtime_1.jsxs)(question_1.default, Object.assign({}, rest, { id: id }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: question_image_clickmap_styles_1.default }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b() }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('image-clickmap') }, { children: [(0, jsx_runtime_1.jsx)("img", { ref: this.imageRef, className: b('image'), src: image, alt: imageLabel, onClick: this.onClickImage, onLoad: this.onLoadImage }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('clickmap') }, { children: clicks.map(({ x, y }) => ((0, jsx_runtime_1.jsx)(pythia_libs_1.ClickPoint, { x: x, y: y, cls: b('click-point') }, `${x};${y}`))) }))] })) })), children] })));
    }
}
exports.default = ImageClickMap;
ImageClickMap.defaultProps = DEFAULT_PROPS;
